import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Filter } from '@brafton/angular-framework-library';
import { ProductsService } from '@brafton/atlas-api-client';
import { ProductType } from '@brafton/common-framework-library';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'shared-filter-panel-content-type',
  templateUrl: './filter-panel-content-type.component.html',
  styleUrls: ['./filter-panel-content-type.component.scss'],
  host: { class: 'filter-panel-content-type' },
})
export class SharedFilterPanelContentTypeComponent implements OnInit {
  @Input() products: Filter[] = [];
  @Output() productsChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  products$!: Observable<ProductType[]>;

  constructor(private productService: ProductsService) { }

  ngOnInit() {
    this.products$ = this.productService.listProducts().pipe(map((r: ProductType[]) => r.sort((a: ProductType, b: ProductType) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)));
  }

  addProduct(productDef: ProductType) {
    if (!this.products.find((sp) => sp.value === productDef.id)) {
      this.products.push({ value: productDef.id, displayName: productDef.name, type: 'contentType' } as Filter);
    }
    this.productsChange.emit(this.products);
  }

  removeProduct(productDef: ProductType) {
    const index = this.products.findIndex((sp) => sp.value === productDef.id);
    if (index > -1) {
      this.products.splice(index, 1);
    }
    this.productsChange.emit(this.products);
  }

  clear() {
    this.products = [];
    this.productsChange.emit(this.products);
  }

  isSelected(productDef: ProductType): boolean {
    if (!this.products) return false;
    if (this.products.find((sp) => sp.value === productDef.id)) return true;
    else return false;
  }
}
